import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalFileShowViewComponent } from 'src/app/components/shared/components/modal-file-show-view/modal-file-show-view.component';
import { EnvService } from 'src/app/services/env.service';
import { UploadFileService } from 'src/app/services/uploadfile.service';

@Component({
  selector: 'create-case-files',
  templateUrl: './create-case-files.component.html',
  styleUrls: ['./create-case-files.component.scss'],
})
export class CreateCaseFilesComponent implements OnInit {
  @Input() files: any[] = [];
  @Output() filesChange = new EventEmitter<any[]>();

  constructor(public _fileUpload: UploadFileService, private env: EnvService,
      private readonly dialog: MatDialog) { }

  ngOnInit() { }

  archivos_adjuntos() {
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.click();
    input.onchange = (e) => this.onFile(e);
  }
  onFile(event: any) {
    const files = event.target.files;
    for (let key of Object.keys(files)) {
      const file = files[key];
      this.uploadFile(file);
    }
  }

  async uploadFile(file: any) {
    const newfile = await this._fileUpload.upload(file).toPromise();
    this.files.push({ file_path: newfile.filename, filename: file.name });
    this.filesChange.emit(this.files);
  }
  async goTo(url: any) {
    window.open(`${this.env.URL_API}/descargar/${url}`, '_blank');
  }

  async deleteFile(filename: string) {
    this.files.map((file: any, i: number) => {
      if (file.filename === filename) this.files.splice(i, 1);
    });
    this.filesChange.emit(this.files);
  }
    view(file) {
            this.dialog
              .open(ModalFileShowViewComponent, {
                data: file,
                minWidth: '1%',
              })
              .afterClosed()
              .subscribe(async (re) => {});
      }
}
